import { render } from "./App.vue?vue&type=template&id=113fef29"
const script = {}

import "./App.vue?vue&type=style&index=0&id=113fef29&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/certificate-site-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__